// Mixin
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"

// Components
const ProductItemCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "product-item-card" */ "@/app/views/main-view/_shared/_components/product-item-card/product-item-card.vue"
	)

export default {
	name: "CartCard",
	components: { ProductItemCard },
	directive: {},
	filters: {},
	mixins: [userMixins, shoppingMixins],
	props: {
		list: {
			type: Object,
			required: true,
		},
		origin: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			ageList: {
				A: "Adult",
				P: "Puppy",
			},
			isReadMore: false,
		}
	},
	methods: {
		checkProductDeactivated(cart) {
			let deactivated = false

			// Check for single product
			if (!cart.isCustomBundle) {
				for (const key in cart.products) {
					const product = cart.products[key]
					if (product.status === "I") {
						deactivated = true
					}
				}
			} else {
				deactivated = cart.bundleStatus === "I"
			}
			return deactivated
		},
		hasProductImage(cart) {
			let imgUrl = require("@/assets/images/product/dog-default-picture-color.png")
			if (!cart.isCustomBundle) {
				for (const key in cart.products) {
					const product = cart.products[key]
					if (product.productImg) {
						imgUrl = product.productImg
						break
					}
				}
			} else {
				if (cart.bundleImg) {
					imgUrl = cart.bundleImg
				}
			}
			return imgUrl
		},
		confirmPriceChange(list) {
			this.$emit("confirmPriceChange", list)
		},
		deleteCart(list) {
			this.$emit("deleteCart", list)
		},

		productOutOfStockModal(list) {
			this.$emit("productOutOfStockModal", list)
		},

		deleteCartModal(list) {
			return this.checkProductOutOfStock(list) ? this.productOutOfStockModal(list) : this.deleteCart(list)
		},

		showImageModal(list) {
			this.$swal({
				imageHeight: 250,
				imageUrl: this.hasProductImage(list),
				imageAlt: "Image",
				title: list.name,
				text: list.description ? list.description : "",
			})
		},
		readMoreAndModal(list) {
			this.showImageModal(list)
		},
		stocksAvailable(stockQty) {
			return stockQty <= 0 || stockQty === null ? "Out of Stock" : `Available Qty: ${stockQty}`
		},
		productWarningText(list) {
			if (list.subscriptionBundle) return

			return this.checkProductDeactivated(list)
				? "This product has been deleted, please delete to cart to proceed."
				: this.checkProductOutOfStock(list)
				? "This product is out of stock, please delete to cart to proceed."
				: ""
		},
	},
}
